'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { HowList } from '../../components/site/how-list'
import { Reveal } from '../../components/site/reveal'
import { SectionHead } from '../../components/site/section-head'
import { SiteSection } from '../../components/site/section'
import { MeetingEditorDemo } from './meeting-editor-demo'

/** 02 · 會議、訪談與課程。 */
export function MeetingDemoSection() {
  const { t } = useTranslation(['web'])

  return (
    <SiteSection trackingKey="meeting_demo">
      <Reveal>
        <SectionHead
          eyebrow={t('web:transcriptionPage.meetings.eyebrow')}
          titleKey="web:transcriptionPage.meetings.title"
          hookKey="web:transcriptionPage.meetings.hook"
          lead={t('web:transcriptionPage.meetings.lead')}
        />
      </Reveal>
      <Reveal className="mt-(--gap-xl)">
        <MeetingEditorDemo />
      </Reveal>
      <Reveal>
        <HowList
          items={['speakers', 'dictionary', 'replay'].map((key) => ({
            title: t(`web:transcriptionPage.meetings.how.${key}Title`),
            description: t(`web:transcriptionPage.meetings.how.${key}Desc`),
          }))}
          note={t('web:transcriptionPage.meetings.how.note')}
        />
      </Reveal>
    </SiteSection>
  )
}
